export default __webpack_public_path__ + "static/media/blue-btn.4cf4873c.png";